import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ExpensesList from './ExpensesList'
import NewExpense from './NewExpense'
import ViewExpense from './ViewExpense'

export default function ExpenseRoute() {
     return (
          <Routes>
               <Route path="/" element={<ExpensesList />} />
               <Route path="/new" element={<NewExpense />} />
               <Route path="/edit/:id" element={<NewExpense />} />
               <Route path="/view/:id" element={<ViewExpense />} />
          </Routes>
     )
}
